<template>
  <label
    :for="elementId"
    class="cg-radio"
    :class="{
      'cg-radio--active': isActive,
      'cg-radio--disabled': disabled,
    }"
  >
    <div class="cg-radio__wrapper">
      <input
        v-model="modelValue"
        type="radio"
        role="radio"
        :aria-checked="isActive ? 'true' : 'false'"
        :aria-disabled="disabled ? 'true' : 'false'"
        :disabled="disabled"
        :id="elementId"
        :name="elementId"
        :value="inputValue"
      >
      <span />
    </div>

    <div class="cg-radio__content">
      <div>
        <!-- @slot The default Vue slot. -->
        <slot />
      </div>

      <div v-if="showSecondaryText">
        <!-- @slot Adds text under the default slot. -->
        <slot name="secondary-text" />
      </div>
    </div>
  </label>
</template>

<script lang="ts">
import { PropType } from 'vue';
import ElementId from '../../mixins/elementId';

type RadioSlots = {
  'default'?: unknown;
  'secondary-text'?: unknown;
}

export default ElementId.extend({
  name: 'CgRadio',
  props: {
    /**
     * The input’s value
     * @model
     */
    value: {
      type: String as PropType<any>,
      required: false,
      default: null,
    },
    /**
     * The value used when the component is selected it will update **v-model**
     */
    inputValue: {
      type: String as PropType<any>,
      required: true,
    },
    // input value
    /**
     * Sets the DOM id on the component
     */
    id: {
      type: String,
      required: false
    },
    /**
     * Removes the ability to click or target the component.
     */
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data: () => ({
    lazyValue: null as any,
  }),
  computed: {
    modelValue: {
      get(): any { return this.lazyValue; },
      set(val: any) {
        this.lazyValue = val;
        /**
         * Emitted when the v-model is changed.
         * 
         * @property {any} value new value
         */
        this.$emit('input', this.lazyValue);
      }
    },
    slots(): RadioSlots {
      return this.$slots;
    },
    showSecondaryText(): boolean {
      return !!this.slots?.['secondary-text'];
    },
    isActive(): boolean {
      return this.lazyValue === this.inputValue;
    }
  },
  watch: {
    value (val: any) {
      this.lazyValue = val;
    },
  },
  mounted() {
    this.lazyValue = this.value;
  },
});
</script>

<style lang="scss" scoped>
@import './styles.scss';
</style>
